import { compose } from 'redux'

import withState from './withState'
import withEventHandlers from './withEventHandlers'

import UI from './UI'

export default compose(withState, withEventHandlers)(UI)
